import { Bounded } from "../geometry.bounds";
export class AbstractShape extends Bounded {
    constructor(t) {
        super();
        this._type = t;
    }
    get type() {
        return this._type;
    }
    [Symbol.iterator]() {
        let index = 0;
        let points = this._getPoints();
        return {
            next() {
                if (index < points.length) {
                    return { value: points[index++], done: false };
                }
                else {
                    return { value: null, done: true };
                }
            },
        };
    }
}
//# sourceMappingURL=geometry.shape.js.map